import Player from './components/Player';
// import FlvPlayer from './components/FlvPlayer';
import Wheel from './components/Wheel';

import './App.css';

function App() {
  return (
    <div className="App">
      <Player />
      {/* <FlvPlayer /> */}
      <Wheel />
    </div>
  );
}

export default App;
